module.exports = __webpack_public_path__ + "media/icons/pdf-file-b0f1932d.png";